// extracted by mini-css-extract-plugin
export default {"parent_option":"ParentOption_parent_option__Qzszv","option":"ParentOption_option__aqynN","add_option":"ParentOption_add_option__5hgcY","close_icon":"ParentOption_close_icon__Kzv2A"};